import type { ReactNode } from "react";

/**
 * Shared two-column auth shell: a centered card on the left (with the standard
 * footer) and the PulsO brand stage + city skyline on the right. Used by both
 * LoginPage and AccessDeniedPage so styling tweaks only live in one place.
 *
 * Pass the card contents as `children`; the brand mark, footer links and brand
 * stage are rendered here.
 */
export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="login">
      {/* Left — card + footer */}
      <div className="login-form-wrap">
        <div className="login-form-card">{children}</div>

        <div className="login-foot">
          <span>© 2026 PulsO</span>
          <span className="flex gap-3">
            <a
              href="https://pulso.city/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground"
            >
              Regulamin
            </a>
            <a
              href="https://pulso.city/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground"
            >
              Polityka prywatności
            </a>
          </span>
        </div>
      </div>

      {/* Right — brand stage */}
      <div className="login-stage">
        <div className="login-stage-inner">
          <div className="brand-logo-wrap">
            <img src="/pulso-logo.svg" alt="PulsO" className="brand-logo" />
          </div>
        </div>

        <div className="city-skyline" aria-hidden="true">
          <svg viewBox="0 0 800 120" preserveAspectRatio="none" width="100%" height="120">
            <path
              d="M0,120 L0,80 L40,80 L40,60 L70,60 L70,75 L90,75 L90,40 L110,40 L110,55 L130,55 L130,45 L160,45 L160,70 L180,70 L180,55 L200,55 L200,30 L215,30 L215,20 L225,20 L225,30 L240,30 L240,65 L260,65 L260,50 L280,50 L280,75 L300,75 L300,55 L320,55 L320,35 L335,35 L335,50 L355,50 L355,80 L380,80 L380,60 L395,60 L395,45 L415,45 L415,25 L435,25 L435,60 L455,60 L455,40 L475,40 L475,70 L495,70 L495,50 L515,50 L515,30 L530,30 L530,15 L545,15 L545,35 L565,35 L565,75 L585,75 L585,55 L605,55 L605,40 L625,40 L625,65 L645,65 L645,55 L665,55 L665,30 L685,30 L685,60 L705,60 L705,45 L725,45 L725,75 L745,75 L745,55 L765,55 L765,70 L790,70 L790,80 L800,80 L800,120 Z"
              fill="rgba(255,255,255,0.05)"
            />
            <path
              d="M0,120 L0,95 L60,95 L60,80 L120,80 L120,90 L180,90 L180,70 L240,70 L240,85 L300,85 L300,75 L360,75 L360,90 L420,90 L420,80 L480,80 L480,95 L540,95 L540,85 L600,85 L600,90 L660,90 L660,80 L720,80 L720,95 L800,95 L800,120 Z"
              fill="rgba(255,255,255,0.07)"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}
